import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppSettings } from "../config/app-settings.js";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../_store";
import registerSchema from "../validation/registerSchema.js";
import background from "../../src/assets/images/banner-img-new.jpg";
import Logo from "../assets/dr_inmate_logo.png";
import { useEffect } from "react";
import { showAlert } from "../components/common/showAlert.js";
import useFullPageLoader from "../hooks/useFullPageLoader";
import ConfirmationModal from "../components/PopupComponent/ConfirmationModal.jsx";
import { EventLog } from "../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../utils/routeTracker.js";


function SendActivateMail() {
  const context = useContext(AppSettings);
  const navigate = useNavigate();
  const [activeMail, setActiveMail] = useState({
    publicUserID: 0,
    userActivateURL: "",
    userType: "PublicUser",
    publicUserEmail: "",
  });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const authUser = useSelector((x) => x.auth.user);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { PublicUserActivationEmailResponse } = useSelector(
    (state) => state.auth
  );
  const [showModal, setShowModal] = useState(false);

  const [modalContent, setModalContent] = useState({
    title: "",
    messageHTML: "",
    message: "",
    showCancelButton: true,
    onConfirm: () => { },
    onCancel: () => { }
  });

  const handlePopupClose = () => {
    navigate("/public/Login");
    storeCurrentRoute("/public/Login");
    setShowModal(false)
  }

  // Validate form using Joi
  const validate = async () => {
    const validationData = {
      email: activeMail.publicUserEmail,
    };
    try {
      await registerSchema.validateAsync(validationData, { abortEarly: false });
      return {};
    } catch (err) {
      const validationErrors = {};
      err.details.forEach((error) => {
        if (error.path[0] === "email") {
          validationErrors.publicUserEmail = error.message;
        }
      });
      return validationErrors;
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validate();
    setErrors(validationErrors);
    if (Object.values(validationErrors).some((error) => error)) {
      return; // Exit if there are any errors
    }
    showLoader();
    dispatch(
      authActions.PublicUserActivationEmailDetails({
        publicUserID: activeMail.publicUserID,
        publicUserEmail: activeMail.publicUserEmail,
        userType: activeMail.userType,
      })
    );
    //  dispatch(authActions.resendActiveMail({ publicUserID: activeMail.publicUserID, userActivateURL: activeMail.userActivateURL, userType: activeMail.userType }));
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setActiveMail((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle reset action
  const handleReset = () => {
    setActiveMail({ publicUserEmail: "" });
    setErrors({});
    const infoMessage = "Activate Mail Page - Clear Input Fields";
    const redirectURL = "public/SendActivateMail";
    const Response = '---';
    const Status = `---`;
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
  };

  // Navigate back to login page
  const handleBack = () => {
    navigate("/public/Login");
  };

  const handleSignUp = (event) => {
    const infoMessage = "Activate Mail Page - Clicked into Sign Up Button";
    const redirectURL = "/public/Register";
    const Response = " --- ";
    const Status = "Redirected into Sign Up page ";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
    navigate("/public/Register");
    storeCurrentRoute("/public/Register");
  };

  // Resend activation email response
  useEffect(() => {
    hideLoader();
    if (
      PublicUserActivationEmailResponse.IsSucceed === 1
    ) {
      setModalContent({
        title: "Resend Activation Mail!",
        messageHTML: ``,
        message: `A confirmation e-mail is sent to '${activeMail.publicUserEmail}' to activate the account.`,
        showCancelButton: false,
        onConfirm: () => {
          handlePopupClose();
        }
      });
      setShowModal(true);
      const infoMessage = "Activate Mail - Clicked Submit Button ( Email - " + activeMail.publicUserEmail + " ) ";
      const redirectURL = " --- ";
      const Response = JSON.stringify(PublicUserActivationEmailResponse);
      const Status = `A confirmation e-mail is sent to '${activeMail.publicUserEmail}' to activate the account.`;
      EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      dispatch(authActions.clearEmailResponse());
    }
    else if (PublicUserActivationEmailResponse.IsSucceed === 2) {
      setModalContent({
        title: "Resend Activation Mail Failed!",
        messageHTML: `If you want to resend the account activation E-mail, you must wait till <strong>${PublicUserActivationEmailResponse.RemainingTime}</strong> Minutes.`,
        message: ``,
        showCancelButton: false,
        onConfirm: () => {
          // showModal(false);  // Hide the modal
          handlePopupClose();
        },
      });
      const infoMessage = "Activate Mail - Clicked Submit Button ( Email - " + activeMail.publicUserEmail + " ) ";
      const redirectURL = " --- ";
      const Response = JSON.stringify(PublicUserActivationEmailResponse);
      const Status = `If you want to resend the account activation E-mail, you must wait till <strong>${PublicUserActivationEmailResponse.RemainingTime}</strong> Minutes.`;
      EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      setShowModal(true);
      dispatch(authActions.clearEmailResponse());
    }
    else if (PublicUserActivationEmailResponse.IsSucceed === 3) {
      setModalContent({
        title: "Resend Activation Mail!",
        messageHTML: ``,
        message: "Your account is already activated.",
        showCancelButton: false,
        onConfirm: () => {
          handlePopupClose();
        },
      });
      const infoMessage = "Activate Mail - Clicked Submit Button ( Email - " + activeMail.publicUserEmail + " ) ";
      const redirectURL = " --- ";
      const Response = JSON.stringify(PublicUserActivationEmailResponse);
      const Status = "Your account is already activated.";
      EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      setShowModal(true);
      dispatch(authActions.clearEmailResponse());
    }
    else if (PublicUserActivationEmailResponse.IsSucceed === 4) {
      setModalContent({
        title: "Resend Activation Mail!",
        messageHTML: ``,
        message: `Your entered e-mail is not Registered yet in our application`,
        showCancelButton: false,
        onConfirm: () => {
          handlePopupClose();
        },
      });
      const infoMessage = "Activate Mail - Clicked Submit Button ( Email - " + activeMail?.publicUserEmail?.trim() + " ) ";
      const redirectURL = " --- ";
      const Response = JSON.stringify(PublicUserActivationEmailResponse);
      const Status = `Your entered e-mail is not Registered yet in our application`;
      EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      setShowModal(true);
      dispatch(authActions.clearEmailResponse());
    }
    else if (PublicUserActivationEmailResponse.ActiveStatus === 0) {
      setModalContent({
        title: "Registration failed!",
        messageHTML: ``,
        message: `Your entered e-mail is Blocked Himself Or Temporarily Blocked by Management User for iIlegal Activites.`,
        showCancelButton: false,
        onConfirm: () => {
          handlePopupClose();
        }
      });
      const infoMessage = "Activate Mail - Clicked Submit Button ( Email - " + activeMail.publicUserEmail + " ) ";
      const redirectURL = " --- ";
      const Response = JSON.stringify(PublicUserActivationEmailResponse);
      const Status = `Your entered e-mail is Blocked Himself Or Temporarily Blocked by Management User for iIlegal Activites.`;
      EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      setShowModal(true);
      dispatch(authActions.clearEmailResponse());

    } else if (PublicUserActivationEmailResponse.DeactivateMyAccount == 1) {
      setModalContent({
        title: "Resend Activation Mail failed!",
        messageHTML: ``,
        message: `Your entered e-mail is already Deactivated.`,
        showCancelButton: false,
        onConfirm: () => {
          handlePopupClose();
        }
      });
      const infoMessage = "Activate Mail - Clicked Submit Button ( Email - " + activeMail.publicUserEmail + " ) ";
      const redirectURL = " --- ";
      const Response = JSON.stringify(PublicUserActivationEmailResponse);
      const Status = `Your entered e-mail is already Deactivated.`;
      EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      setShowModal(true);
      dispatch(authActions.clearEmailResponse());

    }
  }, [PublicUserActivationEmailResponse]);

  return (
    <div className="register register-with-news-feed">
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={modalContent.onConfirm}
        title={modalContent.title}
        messageHTML={modalContent.messageHTML}
        message={modalContent.message}
        showCancelButton={modalContent.showCancelButton}
        onconfirmname="OK"
        oncancelname=""
        size="md p-4"
        closeButton={true}
      />
      <div className="position-absolute top-0 end-0 p-4">
        <span
          className="text-dark fs-12 text-decoration-none"
        >
          <span className="font-size-15">New User <b className="text-danger text-underline" onClick={handleSignUp} style={{ cursor: "pointer" }}>Sign Up</b></span>
        </span>
      </div>
      <div className="news-feed">
        <div
          className="news-image"
          style={{
            backgroundImage: `url(${background})`,
          }}
        ></div>
        <div className="news-caption">
          <h1 className="text-white font-xl">
            <b>INMATE INBOX</b>
          </h1>
          <p className="font-size-20">
            Send & Receive Secure Electronic Messages With Your{" "}
            <span className="default-color">Loved</span> Ones. There’s no better
            way to stay connected with your loved one or friend than real time
            messages.
          </p>
        </div>
      </div>
      <div className="register-container">
        <div className="login-header mb-10px">
          <div className="brand">
            <div
              className="d-flex align-items-center mt-4"
              style={{ justifyContent: "center" }}
            >
              <img src={Logo} className="login-logo" alt=""></img>
            </div>
          </div>
        </div>
        <h2 class="title-default mb-2">Resend Activation Mail</h2>
        <div className="register-content">
          <p class="font-size-16">Please enter your registered e-mail to receive the e-mail with the link to activate your account.</p>

          <form className="fs-13px" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label  w-100 fs-5 mb-2"
                style={{ color: "#20252aa6", fontWeight: "400" }}>
                E-mail <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control mb-5px fs-5 fw-normal ${errors.publicUserEmail ? "input-error" : ""
                  }`}
                placeholder="E-mail"
                id="publicUserEmail"
                name="publicUserEmail"
                value={activeMail.publicUserEmail}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmit(e);
                  }
                }}
              />
              {errors.publicUserEmail && (
                <div className="text-danger fw-700 fs-6 mt-1">{errors.publicUserEmail}</div>
              )}
            </div>
            <div className="mb-4">
              <button type="submit" className="btn btn-theme me-2 font-size-14 mb-2">
                <i class="fa-solid fa-check me-1"></i>
                Submit
              </button>
              <button
                type="button"
                onClick={handleReset}
                className="btn btn-grey font-size-14 mb-2 me-2"
              >
                <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                Reset
              </button>
              {/* <button
                type="button"
                onClick={handleBack}
                className="btn btn-danger w-100px"
              >
                Back
              </button> */}
            </div>
            <div className="mb-4 pb-5 font-size-15">
              Back to <b><Link to="/public/Login" onClick={() => {
                const infoMessage = "Activate Mail Page - click Back button";
                const redirectURL = "/public/Login";
                const Response = '---';
                const Status = " Redirected into login page ";
                EventLog(dispatch, infoMessage, redirectURL, Response, Status)
              }} className="text-default-red text-decoration-underline">Login</Link></b>
            </div>
            <hr className="bg-gray-600 opacity-2" />
            <p className="text-center text-gray-600">
              &copy; Inmate Inbox All Right Reserved {new Date().getFullYear()}
            </p>
          </form>
        </div>
      </div>
      {loader}
    </div>
  );
}

export default React.memo(SendActivateMail);
